import { getBaseProductInMaker, getProductColorInMaker } from '@modules/Maker/F/getSth.js';
import { every, go } from 'fxjs/es';
import { VectorEditorConstantS } from '@modules/VectorEditor/S/Constant/module/VectorEditorConstantS.js';
import { BpOptionUploadTypeS } from '@modules/BpOption/UploadType/S/Function/module/BpOptionUploadTypeS.js';

export const makerStatus = {
  isVectorEditor: () => {
    const base_product = getBaseProductInMaker();
    return VectorEditorConstantS.EDITOR_TYPES.includes(base_product.maker_type);
  },
  isCanvasEditor: () => {
    const base_product = getBaseProductInMaker();
    return ['DEFAULT', 'MASKING_TAPE'].includes(base_product.maker_type);
  },
  isFlexiMaker: () => {
    const base_product = getBaseProductInMaker();
    return base_product.maker_type === 'FLEXI';
  },
  useMcon: () => {
    const base_product = getBaseProductInMaker();
    return G.collabo_type === '' && base_product.use_mcon;
  },
  useEmbro: () => {
    const base_product = getBaseProductInMaker();
    return base_product.can_embro;
  },
  hasNotAnyDesignForCanvasEditor: () => {
    if (!makerStatus.isCanvasEditor()) return;
    const product = getProductColorInMaker();
    if (BpOptionUploadTypeS.UPLOAD_TYPE.isDirectType(product)) return;
    return go(
      product.product_faces2.value,
      every((pf) => !pf.designs?.length),
      (result) => !result,
    );
  },
};
